import { gql } from "apollo-boost";
export const ADD_USER_TYPE = gql`
    mutation AddUserType($data: UserTypeInput) {
        addUserType(data: $data)
    }
`;

export const EDIT_USER_TYPE = gql`
    mutation EditUserType($where: UserTypeWhereInput!, $data: UserTypeInput) {
        editUserType(where: $where, data: $data)
    }
`;

export const DEL_USER_TYPE = gql`
    mutation DelUserType($where: UserTypeWhereInput!) {
        delUserType(where: $where)
    }
`;

export const GET_USER_TYPE = gql`
    query GetUserTypes {
        getUserTypes {
            id
            name
            isOpen
            shop {
                id
            }
            updatedBy {
                firstName
            }
            createdAt
            updatedAt
        }
    }
`;